import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {PanelBody} from '@wordpress/components';
import {useState} from '@wordpress/element';
import Layout from './layout';
import { SlideButton } from '@vayu-blocks/global';
import {VayuBlocksColorControl, VayuBlocksToggleControl, VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';

const panelKeys = [
	'slide-background',
	'slide-effect',
]; 

const initialPanels = {
	slide: '',
	advanced: 'slide-background',
};

const PanelSettings = ({
    attributes,
    setAttributes,
	clientId,
	isSelected
}) => {

	const [hover, sethover] = useState('normal');

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

    const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    return (
		<>
			{isSelected && (
				<>
					<InspectorControls>
						<div className='th-block-ins th-button-panel'>
							<VayuBlocksHeaderTab 
								value={ tab }
								options={[
									{
										label: __( 'Icon', 'vayu-blocks' ),
										value: 'slide',
										icon: 'icon'
									},
									{
										label: __( 'Background', 'vayu-blocks' ),
										value: 'advanced',
										icon: 'colorpalette'
									}
								]}
								onChange={ setTab }
							/>

							{'slide' === tab && (
								<Layout attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>

							) || ('advanced' === tab) && (
								<>
									<PanelBody title={ __( 'Background', 'vayu-blocks' ) }
										opened={openPanels['slide-background']}
										onToggle={() => onTogglePanel('slide-background')} 
										className="th-button-panel"
									> 

									<VayuBlocksToggleControl
										label={ __( 'Global', 'vayu_blocks' ) }
										checked={ attributes.globalbg }
										onChange={ ( value ) => setAttributes( { globalbg: value } )}
										help = "Turning this on will disable the global style."
									/>

									{attributes.globalbg && (
										<>

											<SlideButton  
												button={{ normal: "Normal", hover: "Hover" }}
												onChange={(value)=>handelHover(value)}
												defaultValue={'normal'}
											/>  
							
											{hover === 'normal' && (
												<VayuBlocksColorControl
													onChange={(key, value) => setAttributes({ [key]: value })}
													background={{ value: attributes.advBackground, backgroundKey: 'advBackground' }}
												/>
											)}
											{hover === 'hover' && (
												<VayuBlocksColorControl
													onChange={(key, value) => setAttributes({ [key]: value })}
													background={{ value: attributes.advBackgroundHover, backgroundKey: 'advBackgroundHover' }}
												/>
											)}
										
										
										</>
									)}
									
									</PanelBody>
								</>
							)	
							}
						</div>
					</InspectorControls>  
				</>
			)}

    	</>
	);
}

export default PanelSettings;